export default __webpack_public_path__ + "static/media/Acumin-BdItPro.24b08580.otf";